module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/rotate-right-d82c8500fa7916d7d4f57f7845c4e44a.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/rotate-right.svg
// module id = /fmn
// module chunks = 24